const DB_NAME = "f15m-mastery";
export const CARDS_STORE = "cards";
export const PRACTICE_STORE = "practice";
export const META_STORE = "meta";

/** The upgrade adds practice evidence and a reset generation without rewriting or deleting existing cards. */
export function openLearningDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 3);
    request.onupgradeneeded = () => {
      const db = request.result;
      for (const name of [CARDS_STORE, PRACTICE_STORE, META_STORE]) {
        if (!db.objectStoreNames.contains(name)) db.createObjectStore(name, { keyPath: "id" });
      }
    };
    request.onerror = () => reject(request.error);
    request.onblocked = () =>
      reject(new Error("Close older First 15 Moves tabs to upgrade progress."));
    request.onsuccess = () => {
      const db = request.result;
      db.onversionchange = () => db.close();
      resolve(db);
    };
  });
}

/** A write is saved only after the transaction commits, not just request success. */
export async function learningTransaction<T>(
  name: string | string[],
  mode: IDBTransactionMode,
  action: (store: IDBObjectStore) => IDBRequest<T>
): Promise<T> {
  const db = await openLearningDatabase();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(name, mode);
    let value: T;
    const request = action(transaction.objectStore(typeof name === "string" ? name : name[0]));
    request.onsuccess = () => {
      value = request.result;
    };
    transaction.oncomplete = () => {
      db.close();
      resolve(value);
    };
    transaction.onerror = () => {
      db.close();
      reject(transaction.error || request.error);
    };
    transaction.onabort = () => {
      db.close();
      reject(transaction.error || new Error("Progress save aborted"));
    };
  });
}

export async function learningGeneration(): Promise<number> {
  const row = await learningTransaction(META_STORE, "readonly", (store) => store.get("generation"));
  return row?.value || 0;
}

export function replaceGeneration(tx: IDBTransaction): void {
  const meta = tx.objectStore(META_STORE);
  const request = meta.get("generation");
  request.onsuccess = () => meta.put({ id: "generation", value: (request.result?.value || 0) + 1 });
}
